import { ASSESSMENT } from '../../Assessment/constants/api'

export const ASSESSMENT_EC = `${ASSESSMENT}ec/`
export const ASSESSMENT_EC_UPDATE = `${ASSESSMENT_EC}update`
export const ASSESSMENT_EC_OUTCOME_REPORT = `${ASSESSMENT_EC}outcome_report/`
export const ASSESSMENT_EC_PAPER = `${ASSESSMENT_EC}paper`
export const ASSESSMENT_EC_ALL = `${ASSESSMENT_EC}all`
export const ASSESSMENT_EC_CHANGE_STATUS = `${ASSESSMENT_EC}change/status`
